<template>
  <v-card class="pa-4">
    <v-card-title class="d-flex align-center mt-2 mb-2">
      <v-icon class="mr-2">mdi-barcode-scan</v-icon>
      <h3 class="mb-0">
        <strong>Escanear Contenedor LPN</strong>
      </h3>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="12">
          <v-text-field
            v-model="scannedLPN"
            label="Escanear o ingresar LPN..."
            autocomplete="off"
            autofocus
            variant="filled"
            class="mt-3"
            ref="handleScanLPN"
            @keyup.enter="handleScanLPN"
            @input="scannedLPN = scannedLPN.toUpperCase()"
          >
            <template #prepend-inner>
                <v-icon class="fa-solid fa-barcode mr-2" style="margin-top: 4px; cursor: pointer;">mdi-barcode</v-icon>
              </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-alert color="#D0EBFF">
        <p class="mb-0 text-caption" style="font-size: 1rem;">
          Escanee el código LPN del contenedor que contiene los pedidos
          pickeados.
        </p>
      </v-alert>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ScanLPN",
  emits: ["scanned"],
  data() {
    return {
      scannedLPN: "",
    };
  },
  methods: {
    handleScanLPN() {
      if (!this.scannedLPN) return;

      this.$emit("scanned", this.scannedLPN);
      this.scannedLPN = "";
    },
    
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.handleScanLPN) {
          this.$refs.handleScanLPN.focus();
        }
      });
    },
  },
};
</script>
